import IconSuccess from "../assets/img/svg/check-circle-success.svg";
import IconDanger from "../assets/img/svg/danger.svg";
import BulkOrderWarningIcon from "../assets/img/svg/ic-bulk-warning.svg";
import BulkOrderSuccessIcon from "../assets/img/svg/ic-bulk-success.svg";

const MODAL_TYPES = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

const MODAL_TYPE_COLLECTION = {
  [MODAL_TYPES.SUCCESS]: {
    image: IconSuccess,
    text: "user_profile.modal.lbl_success",
  },
  [MODAL_TYPES.ERROR]: {
    image: IconDanger,
    text: "user_profile.modal.lbl_error",
  },
};

const statusFilterData = [
  { id: "Delivered", name: "Delivered" },
  { id: "Cancelled", name: "Cancelled" },
]

const GPS_JOB_TYPES = {
  PICK_UP: "pick_up",
  DELIVERY_ON_ROUTE: "delivery_on_route",
  SEGMENT_PICK_UP: "pickup",
  SEGMENT_DELIVERY_ON_ROUTE: "delivery"
};

const ORDER_OPS_TYPES = {
  HUB_AND_SPOKE: "Hub",
  POINT_TO_POINT: "P2P",
};

const BULK_ORDER_STATUSES = {
  IMPORTED_WITH_ERROR: "imported_with_error",
  SUBMITTED: "submitted",
  VALIDATION_FAILED: "validation_failed",
  VALIDATION_SUCCEEDED: "validation_succeeded",
  READY_FOR_IMPORT: "ready_for_import",
  IMPORTING: "importing",
  DONE: "done"
}

const BULK_ORDER_DISPLAY = {
  [BULK_ORDER_STATUSES.IMPORTED_WITH_ERROR]: {
    ICON: BulkOrderWarningIcon,
    TEXT: "import_list.lbl_error_found"
  },
  [BULK_ORDER_STATUSES.SUBMITTED]: {
    COLOR: "#212121",
    TEXT: "import_list.lbl_submitted"
  },
  [BULK_ORDER_STATUSES.VALIDATION_FAILED]: {
    COLOR: "#FF4D4F",
    TEXT: "import_list.lbl_failed"
  },
  [BULK_ORDER_STATUSES.VALIDATION_SUCCEEDED]: {
    ICON: BulkOrderSuccessIcon,
    TEXT: "import_list.lbl_validation_successed"
  },
  [BULK_ORDER_STATUSES.READY_FOR_IMPORT]: {
    COLOR: "#0F61FD",
    TEXT: "import_list.lbl_ready_import"
  },
  [BULK_ORDER_STATUSES.IMPORTING]: {
    COLOR: "#616161",
    TEXT: "import_list.lbl_importing"
  },
  [BULK_ORDER_STATUSES.DONE]: {
    COLOR: "#41BD64",
    TEXT: "import_list.lbl_done"
  },
}

const LAYOUTS = {
  DEFAULT: "default", // 'default'
  COMPACT: "compact", // 'auth', // For the pages of authentication eg: login, signup,...
  AUTH: "auth", // 'compact', // Header + hamberger menu for the side bar
}

const INSTRUCTION_SOURCE = {
  ORDER: "order",
  CUSTOMER_ACCOUNT:"customer_account",
  VENDOR: "vendor"
}

const APPLY_KEYS = {
  PICKUP: "pickup",
  DELIVERY:"delivery",
  JOURNEY:"journey"
}

const QSHIP_PLATFORM = "QSHIP";

const ACCESS_TOKEN_REFRESH_THRESHOLD = 60;
const ACCESS_TOKEN_VERIFY_INTERVAL = 60000;

export {
  MODAL_TYPES,
  MODAL_TYPE_COLLECTION,
  statusFilterData,
  GPS_JOB_TYPES,
  ORDER_OPS_TYPES,
  BULK_ORDER_STATUSES,
  BULK_ORDER_DISPLAY,
  LAYOUTS,
  INSTRUCTION_SOURCE,
  APPLY_KEYS,
  QSHIP_PLATFORM,
  ACCESS_TOKEN_REFRESH_THRESHOLD,
  ACCESS_TOKEN_VERIFY_INTERVAL,
};
